export default __webpack_public_path__ + "static/media/spa-image-06.0c061bb7.jpg";